export default __webpack_public_path__ + "static/media/pack8.1c925939.svg";